<template>
    <!-- Global Loading Bar -->
    <!-- <LoadingBar /> -->
    
    <NuxtPage/>
    <Modal style="height:80vh"/>
    <div class="footer">
        <div class="footer-content">
            ©华美顾问2023  &nbsp;&nbsp;  图达科技提供技术支持  &nbsp;&nbsp; <span class="version_display">v{{ version }}</span> <a href="https://beian.miit.gov.cn/" target="_blank">ICP证：粤ICP备11083341号</a>
        </div>
    </div>
    <!-- <PWAPromptWrapper/> -->
    <Watermark v-if="route.path != '/login'" 
        style="top:50px" :text="getWatermarkText()" />
</template>

<script setup lang="ts">
import {onBeforeMount, onMounted} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import version from './version'
import {useIsMobileStore} from '~/stores/isMobileStore'
import {useUserInfoStore} from '@/stores/userInfoStore'
import {useLoadingStore} from '@/stores/loadingState'
import {modal} from '@tian-libs/modal'
import {getUserInfo} from '~/controllers/getUserInfo'
import {getOssUrl} from '~/controllers/content/getOssUrl'
import {lsOss} from '~/controllers/content/lsOss'
import {message} from 'ant-design-vue'

// import PWAPromptWrapper from './components/PWAPrompt/Wrapper.vue'

// import {afterLogin} from '~/pages/loginUtils/afterLogin'

import {useAppLoading} from '~/composables/useAppLoading'

// init tFetch
onBeforeMount(async ()=>{
    try{
        // await tFetch('/api/ping',process.server ? {useFetch} :{useAsyncData})
        // console.log("tFetch inited")
    }catch(e){
        console.log("tFetch init err", e)
    }
})

const nav = ref('')

const route = useRoute()

const userInfoStore = useUserInfoStore()

const getWatermarkText = () => {
    if(userInfoStore.info){
        const phoneLast4 = userInfoStore.info.phone_number ? userInfoStore.info.phone_number.slice(-4) : ''
        return userInfoStore.info.username + ' ' + phoneLast4
    }
    else{
        return ''
    }
}
const loadingStore = useLoadingStore()
const { startInitialLoad, trackRealLoading, completeLoading } = useAppLoading()

// Start loading immediately for first-time visitors
if (typeof window !== 'undefined' && loadingStore.isInitialLoad) {
    startInitialLoad()
    trackRealLoading()
}

const router = useRouter()
const init = async ()=>{
    if (loadingStore.isInitialLoad) {
        loadingStore.setProgress(25, '检查用户状态...')
    }

    console.log('version', version)
    try{

        const isMobileStore = useIsMobileStore()
        
        if(typeof window !== 'undefined'){
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                isMobileStore.value = true
            }
            else{
                isMobileStore.value = false
            }
        }

        if(process.env.NODE_ENV == 'production'){
            // console.log = () => {}
        }
        
            if(typeof window !== 'undefined'){
        nav.value = navigator.userAgent
    }
    }catch(e){
        console.log('mount err', e)
    }


    
    if (loadingStore.isInitialLoad) {
        loadingStore.setProgress(50, '验证登录状态...')
    }
    
    const exemptedPaths = ['/wxp/content']
    if(!exemptedPaths.includes(route.path)){
        const jwt = useCookie('jwt')
        console.log("jwt", jwt)
        if (jwt.value){
            try{
                const userInfoRes = await getUserInfo()
                console.log("userInfoRes", userInfoRes)
                if(!userInfoRes){
                    message.error('登录已过期，请重新登录')
                    if(window.location.pathname != '/login'){
                        router.push('/login')
                    }
                }
            }catch(e){
                console.log("userInfoRes err", e)
                message.error('登录已过期，请重新登录')
                if(window.location.pathname != '/login'){
                    router.push('/login')
                }
            }
        }else{
            console.log("no jwt")
            message.error('登录已过期，请重新登录')
            if(window.location.pathname != '/login'){
                router.push('/login')
            }
        }

    }
    
    if (loadingStore.isInitialLoad) {
        loadingStore.setProgress(100, '初始化完成！')
        setTimeout(() => {
            completeLoading()
        }, 500)
    }
}
await init()

// Hide the initial HTML loader when Vue app is ready
onMounted(() => {
    setTimeout(() => {
        const initialLoader = document.getElementById('initial-loader')
        if (initialLoader) {
            initialLoader.style.opacity = '0'
            setTimeout(() => {
                initialLoader.style.display = 'none'
            }, 500)
        }
    }, 500)
})
</script>

<style scoped>
.footer{
    width: 100%;
    height: 50px;
    background-color: transparent;
    background: #000000;
    position: relative;
    color:rgb(177, 177, 177);
    line-height: 50px;
    font-size: 14px;
    font-weight: 200;
    text-align: center;;
    z-index: 10;
}

@media (max-width: 768px) {
    .footer {
        height: auto;
        line-height: 1.4;
        font-size: 11px;
        padding: 8px 10px;
        word-wrap: break-word;
    }
    
    .footer-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
    }
}


.page-enter-active,
.page-leave-active {
  transition: all 0.4s;
}

.page-enter-from,
.page-leave-to {
  opacity: 0;
  filter: blur(1rem);
}

.version_display{
    color: #636363;
    position: absolute;
    right: 10px;
}

@media (max-width: 768px) {
    .version_display {
        position: static;
        display: block;
        margin-top: 4px;
    }
}
</style>

<style>
.ant-select:not(.ant-select-customize-input) .ant-select-selector,
.ant-input{
    border-radius: 15px;
    font-size: 18px;
    border-color: black;
}
.anticon{
    color:black
}

.grayoutlesshover {
    filter: grayscale(100%);
    transition: filter 0.1s ease-in-out;
}
.grayoutlesshover:hover {
    filter: grayscale(0%);
}

.text_l {
    font-size: 72px;
    line-height: 108px;
    font-weight: 500;
}
.text_m {
    font-size: 36px;
    line-height: 54px;
    font-weight: 500;
}
.text_s {
    font-size: 18px;
    line-height: 27px;
    font-weight: 300;
}

.text_light{
    color: #999;
}
.text_dark{
    color: #000000;
}
</style>

